import { useQuery } from '@tanstack/react-query';

import { useUserState } from '../context/UserContext';
import { type WrappedTRPCClient } from '../helpers/trpcClientTypes';

const DEFAULT = {
  bug: 0,
  featureRequest: 0,
  location: 0,
  datetime: 0,
  camera: 0
};

const useDefaultFactiiis = (client: WrappedTRPCClient) => {
  const { state } = useUserState();
  const isMobile = typeof document === 'undefined';
  const { data } = useQuery({
    queryKey: ['users', 'defaultFactiiis', isMobile],
    queryFn: async () => {
      const [, d] = await client.users.defaultFactiiis.query({ isMobile });
      return d ?? DEFAULT;
    },
    enabled: state.user.isAuthenticated === true,
    staleTime: Infinity
  });
  return data ?? DEFAULT;
};

export default useDefaultFactiiis;
